
export * from '../../../frontend-js-dependencies-web/__liferay__/exports/dom-align.js';

import __default__ from '../../../frontend-js-dependencies-web/__liferay__/exports/dom-align.js';
export default __default__;
